import { render, staticRenderFns } from "./cube.vue?vue&type=template&id=2b297bf7&scoped=true&"
import script from "./cube.vue?vue&type=script&lang=js&"
export * from "./cube.vue?vue&type=script&lang=js&"
import style0 from "./cube.vue?vue&type=style&index=0&id=2b297bf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b297bf7",
  null
  
)

component.options.__file = "cube.vue"
export default component.exports